import { Container } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";
import BrowsingSelectModeBanner from "../../Components/Banners/BrowsingSelectModeBanner/browsing-select-mode-banner";
import SelectModeSubbarOpener from "../../Components/Banners/SelectModeBanner/opener";
import TitleHeroSkeleton from "../../Components/Heros/TitleHero/TiteHeroSkeleton/title-hero-skeleton";
import TitleHero, { TitleHeroProps } from "../../Components/Heros/TitleHero/title-hero";
import TitleSubbar from "../../Components/Subbars/TitleSubbar/title-subbar";
import { assetService } from "../../Core/Api/services";
import { DbAssetObjectInfos, TitleContentData } from "../../Core/Api/Types/db-asset-object-infos";
import GlobalConst from "../../Core/Utils/Constants/globals";
import DashboardLayout from "../../Layouts/Dashboard/dashboard";
import { GetObject, SetFetchedObject, SetLoading } from "../../Redux/Reducers/redux-slice-asset";
import { useAppDispatch, useAppSelector } from "../../Redux/redux-store";
import useCustomSnackbar from "../../Utils/Hooks/useCustomSnackbar";
import TitleContent from "./title-content";
import { useTranslation } from "react-i18next";
import { SetTreeObj, TreeContext } from "../../Redux/Reducers/redux-slice-tree";

export interface TitleData {
  heroData: TitleHeroProps;
  contentData: TitleContentData;
}

const Title: FC<{}> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const enqueueSnackbar = useCustomSnackbar();
  const { id } = useParams();
  const titleId = parseInt(id!);

  const title = useAppSelector(GetObject);
  const [heroTitleData, setHeroTitle] = useState<TitleHeroProps>();
  const [titleContentData, setTitleContentData] = useState<TitleContentData>();
  const [selectedContents, setSelectedContents] = useState<DbAssetObjectInfos[]>([]);

  // Fetching Data
  useEffect(() => {
    console.log("title:UE");

    // Use fresh API
    assetService
      .GetGraph(titleId, true, true, false)
      .then(function (response) {
        if (!response.success) navigate(GlobalConst.DEFAULT_REDIRECT_PATH);
        if (!response || !response.graph) {
          enqueueSnackbar(t("alert:error.unableToFetchTitle", { id: titleId }), "error");
          return;
        }

        console.log("title:GetGraph(" + titleId + ") ok");

        const [_titleHeroData, _titleContentData] = assetService.GetTitleDataFromAssetObject(response.graph);

        dispatch(SetFetchedObject(response));
        dispatch(SetTreeObj({ obj: response.graph, context: TreeContext.AssetHierarchy }));
        dispatch(SetLoading(false));

        setHeroTitle(_titleHeroData);
        setTitleContentData(_titleContentData);
      })
      .catch(function () {
        navigate(GlobalConst.DEFAULT_REDIRECT_PATH);
      });
  }, [id]);

  const handleBrowsingSubbarCloseClick = () => {
    setSelectedContents([]);
  };

  // Really important, avoid to re-render all the TitleContent component while playing web player!
  const memoData = useMemo(() => titleContentData, [titleContentData?.id]);

  return (
    <DashboardLayout
      stickiesVisibleAt={300}
      transparentTopbar
      Subbar={title?.name && <TitleSubbar title={title.name} id={title.id} />}
      Banner={
        <BrowsingSelectModeBanner
          handleCloseClick={handleBrowsingSubbarCloseClick}
          itemsSelected={selectedContents}
          titleId={id}
        />
      }
    >
      <SelectModeSubbarOpener selectedObjects={selectedContents} />
      {!heroTitleData ? <TitleHeroSkeleton /> : <TitleHero {...heroTitleData} />}
      <Container>
        <TitleContent
          titleContentData={memoData}
          selectedContents={selectedContents}
          setSelectedContents={setSelectedContents}
        />
      </Container>
    </DashboardLayout>
  );
};

export default Title;
